import { FC, memo, useRef, useState } from 'react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { useEllipsisDetection } from '@geneui/components';
// Import Components
import Typography from 'components/common/Typography';
// Import Constants
import { l } from 'constants/common';
// Import Styles
import styles from './campaignApprovalInfoModalBody.module.scss';

const COMMENT_MAX_LINES = 2;

interface Props {
    comment: Nilable<string>;
}

const CampaignApprovalComment: FC<Props> = ({ comment }) => {
    const { t } = useTranslation();

    const commentRef = useRef<HTMLSpanElement>(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const isTruncated = useEllipsisDetection(commentRef, [comment]);

    const toggleHandler = () => {
        setIsExpanded((isOpened) => !isOpened);
    };

    if (isEmpty(comment)) {
        return <span className="ellipsis-text kv-value kv-value-css">{t(l.NA)}</span>;
    }

    return (
        <span className={styles.comment}>
            <Typography
                ref={commentRef}
                text={comment ?? ''}
                withEllipsis={!isExpanded}
                withTooltip={false}
                maxLines={COMMENT_MAX_LINES}
                className={styles.commentText}
            />
            {(isTruncated || isExpanded) && (
                <button type="button" className={styles.commentToggle} onClick={toggleHandler}>
                    {t(isExpanded ? l.ShowLess : l.ShowMore)}
                </button>
            )}
        </span>
    );
};

export default memo(CampaignApprovalComment);
